import { Box, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ToggleRow } from "./ToggleRow";

interface BetaSectionProps {
  betaAccess: boolean;
  onToggle: (field: string, value: boolean) => void;
}

export function BetaSection({ betaAccess, onToggle }: BetaSectionProps) {
  const [t] = useTranslation();

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.betaParticipation")}
      </Text>

      <Box>
        <ToggleRow
          label={t("screens.settings.betaOptIn")}
          description={t("screens.settings.betaOptInDesc")}
          checked={betaAccess}
          onChange={(v) => onToggle("beta_access", v)}
          isLast
        />
      </Box>
    </VStack>
  );
}
